if (!customElements.get("zoom-toggle")) {
  class ZoomToggle extends HTMLElement {
    constructor() {
      super();
    }

    /**
     * @param {Event} event
     */
    handleClick(event) {
      event.preventDefault();

      document.dispatchEvent(new CustomEvent("zoom:toggle"));
    }

    connectedCallback() {
      this.addEventListener("click", this.handleClick.bind(this));
    }
  }

  customElements.define("zoom-toggle", ZoomToggle);
}
